import React from 'react';
import ReactDOM from 'react-dom';
import '../sass/index.scss';
import Echo from 'laravel-echo';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { configureFakeBackend } from './services/real.backend';
// import Application from './Application';
import * as serviceWorker from './serviceWorker';
import { initTranslations } from './containers/layout/header-component/language';
import MainApp from './hot';
import chatStorage from './pages/Chat/chatStorage';
import { sendNotification } from './helpers/html5notificator';
import logErrorToMyService from './helpers/logErrorToMyService';
import perfectumStorage from './storages/external/perfectum';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://2e424abe4b1148edab9e234fbd832006@o463725.ingest.sentry.io/5652063',
    integrations: [new Integrations.BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 0.2,
    environment: 'production',
  });
}

initTranslations();
configureFakeBackend();
perfectumStorage.config({
  apiUrl: process.env.NODE_ENV === 'development' ? 'http://localhost:3333/api/connectors/perfectum/v1' : '/api/connectors/perfectum/v1',
});

window.Pusher = require('pusher-js');

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.MIX_PUSHER_APP_KEY || '2345678',
  cluster: process.env.MIX_PUSHER_APP_CLUSTER,
  wsHost: window.location.hostname,
  wsPort: 6001,
  forceTLS: false,
  disableStats: true,
  enabledTransports: ['ws'/* , 'wss' */],
  enableSSL: false,
  // disabledTransports: ['xhr_streaming'],
});

window.Echo
  .channel('test')
  .listen('.test', (e) => {
    // console.log('TEST', e);
  });
window.Echo
  .channel('messages')
  .listen('MessageStatusChanged', (e) => {
    chatStorage.changeStatus(e.message.account, +e.message.status);
  })
  .listen('MessageCreated', (e) => chatStorage.addMessage(e.conversationID, e.message));

// sendNotification('Верните Линуса!', {
//   body: 'Тестирование HTML5 Notifications',
//   icon: 'icon.jpg',
//   dir: 'auto',
// },
// () => alert('Click'));
// console.log(process.env);

// eslint-disable-next-line react/jsx-filename-extension,no-undef
ReactDOM.render(<MainApp />, document.getElementById('root'));

// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.register('service-worker.js');
// }
// serviceWorker.register({});
